"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultShadows = exports.getDefaultBorders = exports.defaultPalette = void 0;
// Important rules for custom color-palette
// Primary and Secondary should have at least 4.5 contrast ratio to eachother
exports.defaultPalette = {
    primary: '#06244B',
    secondary: '#0AA3A3',
    highlight: '#FFCD00',
    hover: '#09838D',
    defaultBackground: '#F1F8F8',
    secondaryBackground: '#C3E7E7',
    // common
    inputBackground: '#ffffff',
    white: '#ffffff',
    grayDark: '#626262',
    grayMiddle: '#A9A8A8',
    grayLight: '#D3D1CF',
    black: '#000000',
    red: '#CB333C',
    green: '#00C19F',
    hightScore: '#93C90E',
    midScore: '#003087',
    lowScore: '#87189D',
};
var getDefaultBorders = function (palette) { return ({
    normal: "1px solid ".concat(palette.grayMiddle),
    dim: "1px solid ".concat(palette.grayLight),
    transparent: '1px solid transparent',
    medium: "4px solid ".concat(palette.grayMiddle),
    large: "8px solid ".concat(palette.grayMiddle),
    primary: "2px solid ".concat(palette.primary),
    secondary: "2px solid ".concat(palette.secondary),
    hover: "2px solid ".concat(palette.hover),
    dotted: "2px dotted ".concat(palette.secondary),
    inputBox: "1px solid ".concat(palette.secondary),
    error: "1px solid ".concat(palette.red),
}); };
exports.getDefaultBorders = getDefaultBorders;
var getDefaultShadows = function (_palette) { return ({
    default: '-5px -5px 10px #FFFFFF, 5px 5px 10px #BDD8D8, 10px 10px 20px rgba(189, 216, 216, 0.5), -10px -10px 20px rgba(255, 255, 255, 0.5)',
    button: '2px 2px 4px rgba(0, 0, 0, 0.25))',
}); };
exports.getDefaultShadows = getDefaultShadows;
